import { Component, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RoutedComponent, RoutedComponentMeta } from '@h5s/util-routing';
import { PsFilterModel } from './components/ps-filter/models/ps-filters-model';
import { PsFilterComponent } from './components/ps-filter/ps-filter.component';
import { PsHeaderComponent } from './components/ps-header/ps-header.component';
import { PsTableComponent } from './components/ps-table/ps-table.component';
import { FEATURE_PS_TRANSLATIONS } from './translations/feature-ps.translations';

const COMPONENTS = [PsHeaderComponent, PsFilterComponent, PsTableComponent];

/**
 * Eventi gestiti all'interno di PsTableComponent
 */
@Component({
  selector: 'h5s-feature-ps',
  imports: [ReactiveFormsModule, ...COMPONENTS],
  templateUrl: './feature-ps.component.html',
  styleUrl: './feature-ps.component.scss',
})
export class FeaturePsComponent extends RoutedComponent {
  /** Traduzioni */
  public readonly translation = FEATURE_PS_TRANSLATIONS;

  public readonly filters = signal<PsFilterModel | null>(null);

  /** Definizione del Tab */
  override meta: RoutedComponentMeta = {
    icon: 'uil uil-file-shield-alt',
    title: this.translation.titleHeader,
  };

  constructor() {
    super();
    this.updateMeta(); // Aggiornamento tab del componente
  }
}
